import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0051',
    ecrans: ['00-2']
});
